/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { ICittaOrderreferenceViewProps } from './citta-orderreference';
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
// export default (props: ICittaOrderreferenceViewProps) => {
//     return (
//         <div className='row'>
//             <h2>Config Value: {props.config.showText}</h2>
//             <h2>Resource Value: {props.resources.resourceKey}</h2>
//         </div>
//     );
// };

export class ICittaOrderreferenceView extends React.PureComponent<ICittaOrderreferenceViewProps> {

    public render(): JSX.Element | null {
        const { orderreferenceWrapper, orderreferenceForm, orderreferenceno } = this.props;
        const { FormWrapper, FormContainer,orderreferenceInput, submitButtton } = orderreferenceForm;
        const orderForm =   <Node {...FormWrapper} >
                                <Node {...FormContainer} >
                                    {orderreferenceInput}
                                    {orderreferenceno}
                                    {submitButtton}
                                </Node>
                            </Node>;
        
        return (
            <Module {...orderreferenceWrapper} >
                {orderForm}
            </Module>
        );
    }
}
export default ICittaOrderreferenceView;
